import React, { PureComponent as Component } from 'react';
import { CardBody, Collapse } from 'reactstrap';
import propTypes from 'prop-types';

import SearchForm from './SearchForm';
import SortForm from './SortForm';

export default class Filters extends Component {
	render() {
		return (
			<Collapse isOpen={this.props.isOpen}>
				<CardBody className="filter-container__card-body">
					<SearchForm
						keyword={this.props.keyword}
						category_id={this.props.category_id}
						categoryOptions={this.props.categoryOptions}
						onInputChange={this.props.onHandleChange}
						onInputChangeAndSubmit={this.props.onHandleChangeAndSubmit}
						onSubmit={this.props.onHandleSearch}
					/>
					<hr />
					<SortForm
						per_page={this.props.per_page}
						sort_by={this.props.sort_by}
						onInputChange={this.props.onHandleChangeAndSubmit}
					/>
				</CardBody>
			</Collapse>
		);
	}
}

Filters.propTypes = {
	keyword: propTypes.string,
	category_id: propTypes.oneOfType([propTypes.number, propTypes.string]),
	categoryOptions: propTypes.array,
	per_page: propTypes.oneOfType([propTypes.number, propTypes.string]),
	sort_by: propTypes.string,
	isOpen: propTypes.bool.isRequired,
	onHandleChange: propTypes.func,
	onHandleChangeAndSubmit: propTypes.func,
	onHandleSearch: propTypes.func
};

Filters.defaultProps = {
	keyword: '',
	category_id: '',
	categoryOptions: [],
	per_page: 50,
	sort_by: 'updated_at_desc'
};
